// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".extra-filter-popup .v-card .v-card__text{padding-inline-end:0;padding-inline-start:0}.extra-filter-popup .v-expansion-panel-header{font-size:1em;font-weight:700}.extra-filter-popup .v-slider__thumb-label{font-size:1em}.extra-filter-popup .difficulty-label{font-size:10px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
